export const CART_URL =
  'https://panaderiaconana.shop/cart/add?id=44082102730803&quantity=1&return_to=/checkout'
